import qs from 'qs';
import utils from './utils';

export default {
    getParsedLocationQuery() {
        const search = this.stripQuestionMark(window.location.search);
        return qs.parse(search);
    },

    stripQuestionMark(search) {
        if (search[0] === '?') {
            return search.slice(1);
        }
        return search;
    },

    parseQuery(query) {
        query = this.stripQuestionMark(query);
        const parsed = qs.parse(query);
        return utils.deepFormat(parsed);
    },

    removeNullsAndStringify(query) {
        let params = utils.removeNulls(query);
        return qs.stringify(params, { skipNulls: true });
    },
    
    stringifyQuery(query) {
        const result = this.removeNullsAndStringify(query);
        return result ? ('?' + result) : '';
    },

    excludePropsFromQuery(excludeProps, query) {
        const clone = Object.assign({}, query);

        excludeProps.forEach((item) => {
            if (clone[item]) {
                delete clone[item];
            }
        });

        return clone;
    },

    compareQueries(query1, query2, excludeProps = []) {
        query1 = this.excludePropsFromQuery(excludeProps, query1);
        query2 = this.excludePropsFromQuery(excludeProps, query2);

        return this.removeNullsAndStringify(query1) == this.removeNullsAndStringify(query2);
    }
}